import { Select } from '@cfs-fixings/shared'
import { SelectHTMLAttributes } from 'react'

type SelectProps = SelectHTMLAttributes<HTMLSelectElement>

const PanelSelect = ({ ...props } : SelectProps) => {
  return (
    <Select
      className="h-[30px] !py-0 text-xs text-gray-550 bg-gray-300"
      {...props}
    />
  )
}

export default PanelSelect
